import React from 'react';
import PropTypes from 'prop-types';

import store from '../../store';

export default class Tab extends React.Component {

	static propTypes = {
		path: PropTypes.string.isRequired,
		title: PropTypes.string.isRequired,
		exact: PropTypes.bool,
		isItem: PropTypes.bool,
		badge: PropTypes.any,
	};
	
	static defaultProps = {
		exact: false,
		isItem: true,
	};
	
	render() {
		return null;
	}
	
}
